/**
 * Modal de logs de auditoria sobre o detalhe V2 da OS.
 */

import React from 'react';
import { History } from 'lucide-react';
import { OrderDetailsV2MenuModal } from './OrderDetailsV2MenuModal';
import { OrderDetailsAuditLogs } from './OrderDetailsAuditLogs';

export function OrderDetailsAuditLogsModal({ open, onClose, orderId, logs, loading, error }) {
  return (
    <OrderDetailsV2MenuModal
      open={open}
      onClose={onClose}
      title="Logs"
      icon={<History size={18} strokeWidth={2} aria-hidden />}
      orderId={orderId}
      titleId="odv2-logs-modal-title"
      closeAriaLabel="Fechar logs"
      panelClassName="odv2-menu-modal-panel--wide"
      bodyClassName="odv2-menu-modal-body--logs"
    >
      <OrderDetailsAuditLogs logs={logs} loading={loading} error={error} />
    </OrderDetailsV2MenuModal>
  );
}
